import React, { useEffect, useState } from 'react';
import { Col, Image, Row, Tabs, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { Button, Loader, Text } from '../../../components';
import { ApiCaller, Colors, Fonts, Images, Utils } from '../../../config';
import { JobActions } from '../../../store/actions';
import carDetailLocation from '../../../assets/images/carDetailLocation.svg'
import { MdCall, MdLocationOn } from "react-icons/md";
import { HiOutlineSearch } from 'react-icons/hi';
import { Input } from 'antd';
// import './style.css';

const { TabPane } = Tabs;

const AssignServiceProvider = () => {
    const { jobId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    const { isLoading, jobsDetail, serviceProviders, serviceProvidersLoading, assignServiceProviderLoading } = useSelector(state => state?.JobsManagementReducer);
    const myJobDetails = jobsDetail?.job;
    const myJobDetailsAssignments = jobsDetail?.assignments;

    // Default tab: "Un Assign" (key "2") based on user request "when the page open the Un Assign tab open"
    const [activeTab, setActiveTab] = useState("2");
    const [assignedServiceProviders, setAssignedServiceProviders] = useState([]);
    const [unassignedServiceProviders, setUnassignedServiceProviders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState(searchParams.get('search') || '');

    useEffect(() => {
        if (jobId) {
            fetchServiceProviders();
        }
    }, [jobId, searchQuery]);

    const fetchServiceProviders = async () => {
        setLoading(true);
        try {
            // Build URL with search param if it exists
            let url = `/admin/job/service-provider/${jobId}/assigned-unassigned`;
            if (searchQuery) {
                url += `?search=${encodeURIComponent(searchQuery)}`;
            }

            const response = await ApiCaller.Get(url);
            console.log("response", response);
            if (response?.status === 200 && response?.data?.data) {
                setAssignedServiceProviders(response.data.data.assignedServiceProviders || []);
                setUnassignedServiceProviders(response.data.data.unassignedServiceProviders || []);
            }
        } catch (error) {
            console.error('Error fetching service providers:', error);
            Utils.showSnackBar({ message: "Failed to fetch service providers", severity: "error" });
        } finally {
            setLoading(false);
        }
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
    };

    // Clear search
    const handleClearSearch = () => {
        setSearchQuery('');
    };


    const handleAssign = (spId) => {
        dispatch(JobActions.assignServiceProvider({ serviceProviderId: spId, jobId: jobId },
            () => {
                Utils.showSnackBar({ message: "Service Provider Assigned Successfully", severity: "success" });
                fetchServiceProviders(); // Refresh the service providers list
            }
        ));
    };

    const renderHeader = () => (
        <Row align="middle" className="mb-20 flex" style={{ alignItems: 'center' }}>
            <Button.Basic
                text=""
                variant="text"
                className="back-button"
                onClick={() => navigate(-1)}
                containerClassName={'back-button-container'}
                startIcon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="19" y1="12" x2="5" y2="12"></line>
                        <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                }
            />
            <Text.Heading
                fontSize={24}
                fontFamily={Fonts["Poppins-SemiBold"]}
                color={Colors.Black}
                fontWeight={600}
                text={"Assign Service Provider"}
            />
        </Row>
    );

    const renderSPCard = (sp, isAssigned) => {
        return (
            <Col xs={24} sm={12} lg={8} key={sp.id} style={{ padding: 10 }}>
                <div className="sp-card">
                    <Row wrap={false} align="top">
                        <Col flex="80px">
                            <Image
                                src={sp?.imageThumbUrl || Images.MobrageIcon}
                                fallback={Images.MobrageIcon}
                                height={60}
                                width={60}
                                className="sp-avatar"
                            />
                        </Col>
                        <Col flex="auto">
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5, overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                <span className="sp-name">
                                    {sp?.fullName}
                                </span>
                            </div>
                            <div>
                                <span className="sp-distance">
                                    {sp?.distance ? Number(sp?.distance).toFixed(2) + " Miles Away" : "N/A"}
                                </span>
                            </div>

                            <div className="info-row">
                                <MdCall />
                                <span>{sp?.phoneNo || "N/A"}</span>
                            </div>

                            <div className="info-row">
                                <img
                                    src={carDetailLocation}
                                    alt="Location Logo"
                                    width={16}
                                    height={16}
                                />
                                <Tooltip title={sp?.address || sp?.userDetail?.businessLocation}>
                                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                        {sp?.address || sp?.userDetail?.businessLocation || "N/A"}
                                    </span>
                                </Tooltip>
                            </div>
                        </Col>
                    </Row>

                    <div className="card-divider" />

                    <Row justify="space-between" gutter={16}>
                        {isAssigned ? (
                            <>
                                <Col span={12} style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ color: '#22c55e', fontWeight: 600, fontSize: 16 }}>
                                        {sp?.assignmentStatus === 'ASSIGNED' ? 'Assigned' : 'Invited'}
                                    </span>
                                </Col>
                                <Col span={12}>
                                    <Button.Basic
                                        text="View Profile"
                                        onClick={() => navigate(`/service-provider/${sp?.id}`)}
                                        buttonStyle={{ width: '100%', backgroundColor: '#40a9ff', color: '#fff', borderRadius: 6, height: 40 }}
                                    />
                                </Col>
                            </>
                        ) : (
                            <>
                                <Col span={12}>
                                    <Button.Basic
                                        text="Profile"
                                        onClick={() => navigate(`/service-provider/${sp?.id}`)}
                                        buttonStyle={{ width: '100%', backgroundColor: '#40a9ff', color: '#fff', borderRadius: 6, height: 40 }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Button.Basic
                                        text="Assign"
                                        onClick={() => handleAssign(sp?.id)}
                                        buttonStyle={{ width: '100%', backgroundColor: '#22c55e', color: '#fff', borderRadius: 6, height: 40 }}
                                    />
                                </Col>
                            </>
                        )}
                    </Row>
                </div>
            </Col>
        )
    };

    return (
        <div className="container" style={{ padding: 20 }}>
            {/* {renderHeader()} */}
            <div className='flex items-center' style={{ display: 'flex', alignItems: 'center' }}>
                <Button.Basic
                    text=""
                    variant="text"
                    className=""
                    onClick={() => navigate(-1)}
                    // containerStyle={{ padding: '0px', width: '2rem', alignSelf:'baseline' }}
                    containerClassName={''}
                    startIcon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16.007" viewBox="0 0 24 16.007">
                        <path id="Icon_ionic-ios-arrow-round-back" data-name="Icon ionic-ios-arrow-round-back" d="M16.577,11.558a1.089,1.089,0,0,1,.008,1.534l-5.06,5.077H30.807a1.084,1.084,0,0,1,0,2.167H11.525l5.068,5.077a1.1,1.1,0,0,1-.008,1.534,1.079,1.079,0,0,1-1.526-.008L8.19,20.019h0a1.217,1.217,0,0,1-.225-.342,1.034,1.034,0,0,1-.083-.417A1.087,1.087,0,0,1,8.19,18.5l6.869-6.919A1.062,1.062,0,0,1,16.577,11.558Z" transform="translate(-7.882 -11.252)" />
                    </svg>

                    }
                />
                <Text.Heading
                    fontSize={24}
                    fontFamily={Fonts["Poppins-SemiBold"]}
                    color={Colors.Black}
                    fontWeight={600}
                    text={"Assign Service Provider"}
                />

            </div>
            <div style={{ background: '#f5f7fa', padding: '20px', borderRadius: 10 }}>
                {/* Tabs and Search Row - Responsive Layout */}
                <Row gutter={[16, 16]} align="center" style={{ marginBottom: 20 }}>
                    {/* Tabs on the left */}
                    <Col xs={24} md={activeTab === "2" ? 16 : 24} lg={activeTab === "2" ? 16 : 24}>
                        <Tabs
                            defaultActiveKey="2"
                            activeKey={activeTab}
                            onChange={setActiveTab}
                            className="custom-tabs"
                            style={{ marginBottom: 0 }}
                        >
                            <TabPane tab="Assign" key="1" />
                            <TabPane tab="Un Assign" key="2" />
                        </Tabs>
                    </Col>

                    {/* Search on the right - only show when Un Assign tab is active */}
                    {activeTab === "2" && (
                        <Col xs={24} md={8} lg={8}>
                            <Input
                                placeholder="Search by name..."
                                prefix={<HiOutlineSearch size={20} />}
                                value={searchQuery}
                                onChange={handleSearchChange}
                                allowClear
                                onClear={handleClearSearch}
                                style={{
                                    borderRadius: 8,
                                    padding: '8px 12px',
                                    fontSize: 14,
                                }}
                            />
                        </Col>
                    )}
                </Row>

                {/* Tab Content */}
                {activeTab === "1" && (
                    <div>
                        {loading ? <Loader.Circular /> : (
                            <Row wrap gutter={[16, 16]}>
                                {assignedServiceProviders?.length > 0 ? (
                                    assignedServiceProviders.map(item => renderSPCard(item, true))
                                ) : (
                                    <Col span={24} style={{ textAlign: 'center', padding: 40 }}>
                                        <p style={{ color: '#999', fontSize: 16 }}>No Service Providers Assigned Yet</p>
                                    </Col>
                                )}
                            </Row>
                        )}
                    </div>
                )}

                {activeTab === "2" && (
                    <div>
                        {loading ? <Loader.Circular /> : (
                            <Row wrap gutter={[16, 16]}>
                                {unassignedServiceProviders?.length > 0 ? (
                                    unassignedServiceProviders.map(item => renderSPCard(item, false))
                                ) : (
                                    <Col span={24} style={{ textAlign: 'center', padding: 40 }}>
                                        <p style={{ color: '#999', fontSize: 16 }}>
                                            {searchQuery ? `No Service Providers Found for "${searchQuery}"` : 'No Service Providers Found Nearby'}
                                        </p>
                                    </Col>
                                )}
                            </Row>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AssignServiceProvider;
